<template>
<div class="view">
  <loader v-if="loader"></loader>

  <background
    :image="ui.bg"
  ></background>

  <fixed-header
    :brand="ui.name"
    :logo="ui.logo"
  ></fixed-header>

  <main class="main">
    <transition name="panel">
      <div class="panel panel--welcome" v-if="currentView === 'welcome'" key="welcome">
        <div class="container">
          <div class="row no-gutters justify-content-center">
            <div class="col col-md-6 col-lg-4">
              <div class="panel-header">
                <div class="logo">
                  <img :src="ui.logo">
                </div>
                <div class="title" v-if="$route.query.via === 'order'">{{ $t('entry.welcome:titleOrder', { brand: ui.name }) }}</div>
                <div class="title" v-else-if="$route.query.via === 'ocard-rewards-partner'">{{ $t('entry.welcome:titleOcardRewardsPartner', { brand: ui.name }) }}</div>
                <div class="title" v-else>{{ $t('entry.welcome:title', { brand: ui.name }) }}</div>
              </div>
              <div class="panel-body">
                <div v-if="isCellLoginAllow" class="row narrow-gutters">
                  <div class="col">
                    <button class="btn btn-lg btn-block"
                      v-on:click="activeLogin()">
                      {{ $t('entry.welcome:loginWithMobileNumber') }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="panel-footer">
                <template v-if="ui.terms">
                  <div class="caption" v-html="$t('entry.common:termsWithDataAndExternal', { brand: ui.name, data: ui.required, dataEn: ui.requiredEn, external: ui.terms })" v-if="ui.required"></div>
                  <div class="caption" v-html="$t('entry.common:termsWithExternal', { external: ui.terms })" v-else></div>
                </template>
                <template v-else>
                  <div class="caption" v-html="$t('entry.common:termsWithData', { brand: ui.name, data: ui.required, dataEn: ui.requiredEn })" v-if="ui.required"></div>
                  <div class="caption" v-html="$t('entry.common:terms')" v-else></div>
                </template>
              </div>
              <i18n-picker></i18n-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel--lack" v-if="currentView === 'lack'" key="lack">
        <div class="container">
          <div class="row no-gutters justify-content-center">
            <div class="col col-md-6 col-lg-4">
              <div class="panel-header">
                <div class="logo">
                  <img :src="ui.logo">
                </div>
                <div class="title">{{ $t('entry.lack:title', { brand: ui.name }) }}</div>
              </div>
              <div class="panel-body">
                <button class="btn btn-lg btn-block"
                  v-on:click="fillout()">
                  {{ $t('entry.lack:btn')}}
                </button>
              </div>
              <div class="panel-footer">
                <div class="caption" v-html="$t('entry.common:termsWithData', { brand: ui.name, data: ui.required, dataEn: ui.requiredEn })" v-if="ui.required"></div>
                <div class="caption" v-html="$t('entry.common:terms')" v-else></div>
              </div>
              <i18n-picker></i18n-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel--invite" v-if="currentView === 'invite'" key="invite">
        <div class="container">
          <div class="row no-gutters justify-content-center">
            <div class="col col-md-6 col-lg-4">
              <div class="panel-header">
                <div class="logo">
                  <img :src="ui.logo">
                </div>
                <div class="title">{{ $t('entry.invite:title', { brand: ui.name }) }}</div>
              </div>
              <div class="panel-body">
                <button class="btn btn-lg btn-block"
                  v-on:click="acceptInvite($event)">
                  {{ $t('entry.common:accept') }}
                  <div class="btn-loader"><span></span><span></span><span></span></div>
                </button>
              </div>
              <div class="panel-footer">
                <template v-if="ui.terms">
                  <div class="caption" v-html="$t('entry.common:termsWithDataAndExternal', { brand: ui.name, data: ui.required, dataEn: ui.requiredEn, external: ui.terms })" v-if="ui.required"></div>
                  <div class="caption" v-html="$t('entry.common:termsWithExternal', { external: ui.terms })" v-else></div>
                </template>
                <template v-else>
                  <div class="caption" v-html="$t('entry.common:termsWithData', { brand: ui.name, data: ui.required, dataEn: ui.requiredEn })" v-if="ui.required"></div>
                  <div class="caption" v-html="$t('entry.common:terms')" v-else></div>
                </template>
              </div>
              <i18n-picker></i18n-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel--login" v-if="currentView === 'login'" key="login">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col col-md-6 col-lg-4 col-lg-4">
              <div class="panel-header">
                <div class="logo">
                  <img :src="ui.logo">
                </div>
                <div class="title">
                  {{ $t('entry.login:title') }}
                </div>
              </div>
              <div class="panel-body">
                <form class="form" action="#" v-on:submit.prevent="submitLogin()">
                  <div class="row no-gutters">
                    <div class="col-5 cell-country__container">
                      <country-select
                        class="cell-country" v-on:select-country="selectedCountry($event)" :defaultCountry="cellCountry"></country-select>
                    </div>
                    <div class="col-7">
                      <input type="tel" class="cell" :placeholder="$t('entry.common:mobileNumber')" v-model="cell">
                    </div>
                  </div>
                  <div class="gap"></div>
                  <div class="row no-gutters">
                    <div class="col">
                      <input type="password" :placeholder="$t('entry.login:password')" v-model="password">
                    </div>
                  </div>
                  <div class="gap"></div>
                  <a v-on:click="activePasswordReset()" class="tool-link">
                    {{ $t('entry.login:forgotPassword')}}
                  </a>
                  ・
                  <a v-on:click="activeSignup()" class="tool-link">
                    {{ $t('entry.login:createAccount') }}
                  </a>
                  <input type="submit" class="invisable-submit">
                </form>
              </div>
              <div class="panel-footer">
                <div class="row narrow-gutters">
                  <div class="col-auto">
                    <button class="btn btn-lg btn-block btn-secondary" v-on:click="cancelLogin()">{{ $t('common.cancel') }}</button>
                  </div>
                  <div class="col">
                    <button class="btn btn-lg btn-block" v-on:click="submitLogin($event)">
                      {{ $t('common.submit') }}
                      <div class="btn-loader"><span></span><span></span><span></span></div>
                    </button>
                  </div>
                </div>
              </div>
              <i18n-picker></i18n-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel--login-via-whatsapp" v-if="currentView === 'login-via-whatsapp'" key="login-via-whatsapp">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col col-md-6 col-lg-4 col-lg-4">
              <div class="panel-header">
                <div class="logo">
                  <img :src="ui.logo">
                </div>
                <div class="title">
                  {{ $t('entry.loginViaWhatsapp:title', { brand: ui.name }) }}
                </div>
                <div class="caption" v-if="whatsappAccountInstance">{{ $t('entry.loginViaWhatsapp:whatsappAccount') }} {{ whatsappAccountInstance.getNumber('international') }}</div>
              </div>
              <div class="panel-body">
                <button class="btn btn-lg btn-block btn-whatsapp" v-on:click="loginViaWhatsApp($event)">
                  {{ $t('entry.loginViaWhatsapp:loginWithWhatsapp') }}
                  <div class="btn-loader"><span></span><span></span><span></span></div>
                </button>
                <div class="row narrow-gutters">
                  <div class="col">
                    <button class="btn btn-lg btn-block" v-on:click="cancelLogin()">
                      {{ $t('entry.loginViaWhatsapp:loginWithOther') }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="panel-footer">
                <template v-if="ui.terms">
                  <div class="caption" v-html="$t('entry.common:termsWithDataAndExternal', { brand: ui.name, data: ui.required, dataEn: ui.requiredEn, external: ui.terms })" v-if="ui.required"></div>
                  <div class="caption" v-html="$t('entry.common:termsWithExternal', { external: ui.terms })" v-else></div>
                </template>
                <template v-else>
                  <div class="caption" v-html="$t('entry.common:termsWithData', { brand: ui.name, data: ui.required, dataEn: ui.requiredEn })" v-if="ui.required"></div>
                  <div class="caption" v-html="$t('entry.common:terms')" v-else></div>
                </template>
              </div>
              <i18n-picker></i18n-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel--cell" v-if="currentView === 'cell'" key="cell">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col col-md-6 col-lg-4">
              <div class="panel-header">
                <div class="logo">
                  <img :src="ui.logo">
                </div>
                <div class="title">
                  {{ $t('entry.verify:title') }}
                </div>
                <div class="caption">
                  {{ $t('entry.verify:desc') }}
                </div>
              </div>
              <div class="panel-body">
                <form class="form" v-on:submit.prevent="sendVerifySMS()">
                  <div class="row no-gutters" :class="{ readonly: verifySent }">
                    <div class="col-5 cell-country__container">
                      <country-select
                        class="cell-country" v-on:select-country="selectedCountry($event)" :defaultCountry="cellCountry"
                        :disabled="$route.query.via === 'ocard-rewards-partner'"
                      ></country-select>
                    </div>
                    <div class="col-7">
                      <input type="tel" class="cell" :placeholder="$t('entry.common:mobileNumber')" v-model="cell"
                        :readonly="$route.query.via === 'ocard-rewards-partner'"
                      >
                    </div>
                  </div>
                </form>
                <form class="form" v-on:submit.prevent>
                  <div class="row no-gutters" v-if="verifySent">
                    <div class="col-12">
                      <div class="gap"></div>
                      <input type="text" :placeholder="$t('entry.verify:code')" pattern="[0-9]*" inputmode="numeric" v-model="verifyCode" maxlength="4" autocomplete="one-time-code">
                    </div>
                    <div class="col-12">
                      <div class="gap"></div>
                      <template v-if="$route.query.via !== 'ocard-rewards-partner'">
                        <a class="tool-link" v-on:click="changeCell()" v-if="flow !== 'passwordReset'">{{ $t('entry.verify:change') }}</a>・
                      </template>
                      <a class="tool-link" v-on:click="resendVerifySMS()">{{ $t('entry.verify:resend') }}</a>
                      <span>・</span>
                      <a class="tool-link" v-on:click="createAutopass()">{{ $t('entry.verify:help') }}</a>
                    </div>
                  </div>
                </form>
              </div>
              <div class="panel-footer">
                <div class="row narrow-gutters" v-if="!verifySent">
                  <div class="col-auto">
                    <button class="btn btn-lg btn-block btn-secondary" v-on:click="cancelSignup()">{{ $t('common.cancel') }}</button>
                  </div>
                  <div class="col">
                    <button class="btn btn-lg btn-block" v-on:click="sendVerifySMS($event)">
                      {{ $t('common.next') }}
                      <div class="btn-loader"><span></span><span></span><span></span></div>
                    </button>
                  </div>
                </div>
                <div class="row narrow-gutters" v-if="verifySent">
                  <div class="col">
                    <button class="btn btn-lg btn-block" v-on:click="verifyCell($event)">
                      {{ $t('common.submit') }}
                      <div class="btn-loader"><span></span><span></span><span></span></div>
                    </button>
                  </div>
                </div>
              </div>
              <div class="recaptcha-terms" v-html="$t('entry.common:recaptchaTerms')" />
              <i18n-picker></i18n-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel--password" v-if="currentView === 'password'" key="password">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col col-md-6 col-lg-4 col-lg-4">
              <div class="panel-header">
                <div class="logo">
                  <img :src="ui.logo">
                </div>
                <div class="title">
                  {{ $t('entry.password:title') }}
                </div>
                <div class="caption">
                  {{ $t('entry.password:desc', { number: this.cellInstance.getNumber('international').replace(/ /g, '-') || '' }) }}
                </div>
              </div>
              <div class="panel-body">
                <form class="form">
                  <div class="row no-gutters">
                    <div class="col">
                      <input type="password" :placeholder="$t('entry.password:input')" v-model="newPassword">
                    </div>
                  </div>
                  <div class="gap"></div>
                  <div class="row no-gutters">
                    <div class="col">
                      <input type="password" :placeholder="$t('entry.password:confirm')" v-model="newPasswordComfirm">
                    </div>
                  </div>
                </form>
              </div>
              <div class="panel-footer">
                <div class="row narrow-gutters">
                  <div class="col">
                    <button class="btn btn-lg btn-block" v-on:click="setPassword($event)">
                      {{ $t('common.submit') }}
                      <div class="btn-loader"><span></span><span></span><span></span></div>
                    </button>
                  </div>
                </div>
              </div>
              <i18n-picker></i18n-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel--profile" v-if="currentView === 'profile'" key="profile">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col col-md-6 col-lg-4 col-lg-4">
              <div class="panel-header">
                <div class="title">
                  {{ $t('entry.profile:title') }}
                </div>
                <div class="caption">
                  {{ $t('entry.profile:desc') }}
                </div>
              </div>
              <div class="panel-body">
                <div class="o-form">
                  <div class="row no-gutters">
                    <div class="col">
                      <div class="o-form__row">
                        <div class="o-form__icon">
                          <i class="material-icons">portrait</i>
                        </div>
                        <div class="o-form__content">
                          <div class="o-form__label">
                            {{ $t('entry.profile:name') }}
                          </div>
                          <div class="o-form__value">
                            <input type="text" class="o-form__input" :placeholder="$t('common.enter')" v-model.trim="name">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row no-gutters">
                    <div class="col">
                      <div class="o-form__row">
                        <div class="o-form__icon">
                          <i class="material-icons">wc</i>
                        </div>
                        <div class="o-form__content">
                          <div class="o-form__label">
                            {{ $t('entry.profile:gender') }}
                          </div>
                          <div class="o-form__value">
                            <div class="pill-radio">
                              <input class="pill-radio__input" type="radio" id="male" value="1" v-model="gender">
                              <label for="male" class="pill-radio__label">{{ $t('entry.profile:male') }}</label>
                            </div>
                            <div class="pill-radio">
                              <input class="pill-radio__input" type="radio" id="female" value="0" v-model="gender">
                              <label for="female" class="pill-radio__label">{{ $t('entry.profile:female') }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row no-gutters">
                    <div class="col">
                      <div class="o-form__row">
                        <div class="o-form__icon">
                          <i class="material-icons">today</i>
                        </div>
                        <div class="o-form__content">
                          <div class="o-form__label">
                            {{ $t('entry.profile:birthday') }}
                          </div>
                          <div class="o-form__value">
                            <datepicker
                              :value="birthday"
                              :yearFirst="true"
                              v-on:update:date="birthday = $event"
                              :yearLength="100"
                              :yearOffset="-100"
                              ref="datepicker"
                            ></datepicker>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="custom-fields-title" v-if="customFields.length">{{ $t('entry.common:additionalInformation') }}</div>

                  <div
                    class="row"
                    v-for="field in customFields"
                    v-bind:key="field.field || field"
                  >
                    <div
                      class="col"
                      v-if="field.type === 'email'"
                    >
                      <div class="o-form__row">
                        <div class="o-form__content full">
                          <div
                            class="o-form__label"
                            :class="{ 'is-mandatory': field.mandatory }"
                          >
                            {{ $t('entry.profile:email') }}
                          </div>
                          <div class="o-form__value">
                            <input type="email" class="o-form__input" :placeholder="$t('common.enter')" v-model.trim="customFieldsData[field.field]" inputmode="email">
                          </div>
                        </div>
                      </div>
                    </div>
                    <template
                      v-if="field.type === 'loc'"
                    >
                      <div class="col">
                        <div class="o-form__row">
                          <div class="o-form__content full">
                            <div
                              class="o-form__label"
                              :class="{ 'is-mandatory': field.mandatory }"
                            >
                              {{ field.label || $t('entry.profile:locationCity') }}
                            </div>
                            <div class="o-form__value">
                              <select
                                class="o-form__select"
                                v-on:change="locationAreaOptions = locationOptions[Number($event.target.value)] ? locationOptions[Number($event.target.value)].AreaList : []; customFieldsData[field.field] = null"
                                required
                              >
                                <option>{{ $t('common.select') }}</option>
                                <option
                                  v-for="(city, index) in locationOptions"
                                  v-bind:key="city.CityName"
                                  :value="index"
                                >{{ $root.$i18n.locale === 'zh-Hant' ? city.CityName : city.CityEngName }}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="o-form__row">
                          <div class="o-form__content full">
                            <div
                              class="o-form__label"
                              :class="{ 'is-mandatory': field.mandatory }"
                            >
                              {{ $t('entry.profile:locationArea') }}
                            </div>
                            <div class="o-form__value">
                              <select
                                class="o-form__select"
                                v-model="customFieldsData[field.field]"
                                required
                              >
                                <option :value="null">{{ $t('common.select') }}</option>
                                <option
                                  v-for="area in locationAreaOptions"
                                  v-bind:key="area.ZipCode + area.AreaName"
                                  :value="area.value"
                                >{{ $root.$i18n.locale === 'zh-Hant' ? area.AreaName : area.AreaEngName }}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <div
                      class="col"
                      v-if="field.type === 'text' || field.type === 'number' || field.type === 'tel'"
                    >
                      <div class="o-form__row">
                        <div class="o-form__content full">
                          <div
                            class="o-form__label"
                            :class="{ 'is-mandatory': field.mandatory }"
                          >{{ field.label }}</div>
                          <div class="o-form__value">
                            <input
                              :type="field.type"
                              class="o-form__input"
                              :placeholder="field.help ? $t('common.enter') + field.help :  $t('common.enter')"
                              v-model.trim="customFieldsData[field.field]"
                              :pattern="field.pattern || null"
                              :inputmode="customFieldInputmode(field)"
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col"
                      v-if="typeof field === 'object' && field.type === 'select'"
                    >
                      <div class="o-form__row">
                        <div class="o-form__content full">
                          <div
                            class="o-form__label"
                            :class="{ 'is-mandatory': field.mandatory }"
                          >{{ field.label }}</div>
                          <div class="o-form__value">
                            <select
                              class="o-form__select"
                              v-model="customFieldsData[field.field]"
                              required
                            >
                              <option :value="null">{{ $t('common.select') }}</option>
                              <option
                                v-for="option in field.options"
                                v-bind:key="field + option.label"
                                :value="option.options || option.value"
                              >{{ option.label }}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <template
                      v-if="typeof field === 'object' && field.type === 'combo-select'"
                    >
                      <div class="col">
                        <div class="o-form__row">
                          <div class="o-form__content full">
                            <div
                              class="o-form__label"
                              :class="{ 'is-mandatory': field.mandatory }"
                            >{{ field.label }}</div>
                            <div class="o-form__value">
                              <select
                                v-model="customFieldsComboData[field.field]"
                                v-on:change="customFieldsData[field.field] = null"
                                class="o-form__select"
                                required
                              >
                                <option :value="null">{{ $t('common.select') }}</option>
                                <option
                                  v-for="option in field.options"
                                  v-bind:key="field + option.label"
                                  :value="option.options"
                                >{{ option.label }}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="o-form__row">
                          <div class="o-form__content full">
                            <div
                              class="o-form__label"
                              :class="{ 'is-mandatory': field.mandatory }"
                            ></div>
                            <div class="o-form__value">
                              <select
                                class="o-form__select"
                                v-model="customFieldsData[field.field]"
                                required
                              >
                                <option :value="null">{{ $t('common.select') }}</option>
                                <option
                                  v-for="option in customFieldsComboData[field.field]"
                                  v-bind:key="field + option.label"
                                  :value="option.value"
                                >{{ option.label }}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="panel-footer">
                <div class="row narrow-gutters">
                  <div class="col">
                    <button class="btn btn-lg btn-block" v-on:click="setProfile($event)">
                      {{ $t('common.submit') }}
                      <div class="btn-loader"><span></span><span></span><span></span></div>
                    </button>
                  </div>
                </div>
              </div>
              <i18n-picker></i18n-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel--autopass" v-if="currentView === 'autopass'" key="autopass">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col col-md-6 col-lg-4 col-lg-4">
              <div class="panel-header">
                <div class="icon">
                  <i class="material-icons">help_outline</i>
                </div>
                <div class="title">
                  {{ $t('entry.autopass:title') }}
                </div>
              </div>
              <div class="panel-body">
                <div class="des" v-html="$t('entry.autopass:desc')"></div>
                <div class="row narrow-gutters">
                  <div class="col">
                    <a class="btn btn-lg btn-block" :href="'sms:' + autopassCell + '&body=' + encodeURIComponent(autopassSMS)">
                      {{ $t('entry.autopass:iosBtn') }}
                    </a>
                  </div>
                  <div class="col">
                    <a class="btn btn-lg btn-block" :href="'sms:' + autopassCell + '?body=' + encodeURIComponent(autopassSMS)">
                      {{ $t('entry.autopass:androidBtn') }}
                    </a>
                  </div>
                </div>
                <p>{{ $t('entry.autopass:desc2', { number: autopassCell } ) }}</p>
                <textarea class="autopassSMS" rows="3" v-html="autopassSMS"></textarea>
              </div>
              <div class="panel-footer">
                <div class="row narrow-gutters">
                  <button class="btn btn-lg btn-block" v-on:click="autopassDone()">
                    {{ $t('common.back') }}
                  </button>
                </div>
              </div>
              <i18n-picker></i18n-picker>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </main>

</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import swal from 'sweetalert2';
import AwesomePhonenumber from 'awesome-phonenumber';

import Mixin from '@/mixins';
import Axios from '@/helpers/axios';
import CityCountry from '@/helpers/city-country.json';

import Loader from '@/components/Loader.vue';
import I18nPicker from '@/components/I18nPicker.vue';
import Datepicker from '@/components/DatePicker.vue';
import Background from '@/components/Entry/Background.vue';
import FixedHeader from '@/components/Entry/Fixed-Header.vue';
import CountrySelect from '@/components/Entry/Country-Select.vue';

const moment = require('moment');
require('moment/locale/zh-tw');

export default {
  name: 'Entry',
  mixins: [Mixin],
  data() {
    return {
      // Flow
      flow: null,
      cellRequired: false,
      profileRequired: false,

      // UI
      currentView: 'welcome',
      isCellLoginAllow: false,
      ui: {
        id: null,
        name: null,
        logo: null,
        bg: null,
        required: null,
        terms: null,
      },
      title: '',

      // Firebase / Facebook
      facebookAccessToken: null,
      facebookId: '',
      facebookName: '',
      facebookBirthday: '',
      facebookGender: '',
      facebookEmail: '',
      facebookAvatar: '',

      // Login + Cell
      cellCountry: 'TW',
      cell: '',

      // Login
      password: '',
      whatsappAccount: '',

      // Cell
      verifyCode: '',
      verifySent: false,
      newPassword: '',
      newPasswordComfirm: '',

      // Autopass
      autopassCell: '',
      autopassSMS: '',

      // Profile
      name: '',
      gender: null,
      birthday: null,
      customFields: [],
      customFieldsData: {},
      customFieldsComboData: {},
      locationOptions: CityCountry,
      locationAreaOptions: CityCountry[0].AreaList,
      isSMSResending: false,
    };
  },
  computed: {
    ...mapState([
      'loader',
      'basic',
      'client',
    ]),
    cellInstance() {
      return new AwesomePhonenumber(this.cell, this.cellCountry);
    },
    whatsappAccountInstance() {
      if (this.whatsappAccount) return null;
      const regionCode = new AwesomePhonenumber(this.whatsappAccount).getRegionCode();
      return new AwesomePhonenumber(this.whatsappAccount, regionCode);
    },
    isValidCell() {
      return (this.cellInstance.isValid() && this.cellInstance.isMobile());
    },
  },
  watch: {
    currentView(value) {
      if (value === 'welcome') {
        this.flow = null;
      } else if (value === 'redirect') {
        this.setLoader(true);
        this.gotoReturnURL();
      }
    },
    facebookName(value) {
      this.name = value;
    },
    facebookGender(value) {
      if (value === 'male') {
        this.gender = '1';
      } else if (value === 'female') {
        this.gender = '0';
      }
    },
    facebookBirthday(value) {
      if (value) {
        // const facebookBirthday = this.facebookBirthday.split('/');
        // this.birthday = new Date(Date.UTC(
        //   facebookBirthday[2],
        //   facebookBirthday[0] - 1,
        //   facebookBirthday[1],
        //   0, 0, 0, 0,
        // ));
      }
    },
  },
  methods: {
    ...mapMutations([
      'setLoader',
      'setDtk',
      'setUtk',
    ]),
    formatter(date) {
      return moment(date).format('l');
    },
    customFieldInputmode(field) {
      if (typeof field === 'string' && field === 'email') {
        return 'email';
      } else if (typeof field === 'object' && field.type === 'tel') {
        return 'tel';
      } else if (typeof field === 'object' && field.type === 'number') {
        return 'numeric';
      }

      return 'text';
    },

    // Flow
    checkRequirement(required) {
      this.cellRequired = required.includes('cell');
      this.profileRequired = required.includes('info');

      this.customFields = [];
      this.customFieldsData = {};
      this.customFieldsComboData = {};

      required.forEach((field) => {
        if (field !== 'cell' && field !== 'info') {
          this.customFields.push(field);
          if (field.type === 'combo-select') {
            this.$set(this.customFieldsComboData, field.field, null);
            this.$set(this.customFieldsData, field.field, null);
          } else {
            this.$set(this.customFieldsData, field.field || field, null);
          }
        }
      });
    },
    autofillUserData(data) {
      if ('name' in data) {
        this.name = data.name;
      }
      if ('sex' in data) {
        this.gender = data.sex;
      }
      if ('birth' in data && data.birth) {
        this.birthday = moment(data.birth, 'YYYY-MM-DD').toDate();
      }
    },
    clearLoginvia() {
      const query = Object.assign({}, this.$route.query);
      if (query.flow) {
        delete query.flow;
      }
      if (query.leaveFrom) {
        delete query.leaveFrom;
      }
      this.$router.replace({ path: this.$route.path, query });
    },

    // API
    selectedCountry(value) {
      this.cellCountry = value;
    },

    // Fillout
    fillout() {
      this.flow = 'fillout';
      if (this.cellRequired) {
        this.currentView = 'cell';
      } else {
        this.currentView = 'profile';
      }
    },

    // Invite
    acceptInvite(event) {
      const eventTarget = event.target;

      const data = {
        ...this.$route.query,
        lang: this.$i18n.locale,
        p: this.client.phoneType,
        dtk: this.client.dtk,
        brand_id: this.$route.params.brand,
      };

      eventTarget.classList.add('btn-loading');

      Axios({
        method: 'post',
        url: '/vip/vipAccept',
        data,
      })
        .then((response) => {
          eventTarget.classList.remove('btn-loading');
          this.checkRequirement(response.data.data.require);
          this.autofillUserData(response.data.data.user_data);

          if (response.data.code === 500) {
            if (this.cellRequired || this.profileRequired || this.customFields.length !== 0) {
              this.currentView = 'lack';
            } else {
              this.currentView = 'redirect';
            }
          } else {
            this.$root.$message.error(response.data.msg);
          }
        });
    },

    // Login
    activeLogin() {
      this.currentView = 'cell';
    },
    cancelLogin() {
      this.currentView = 'welcome';
    },
    submitLogin(event) {
      const eventTarget = event.target;

      if (!this.isValidCell) {
        swal.fire({
          text: this.$i18n.t('entry.common:mobileNumberIncorrect'),
          confirmButtonText: this.$i18n.t('common.back'),
        });

        return;
      }

      if (!this.password) {
        swal.fire({
          text: this.$i18n.t('entry.login:passwordEmpty'),
          confirmButtonText: this.$i18n.t('common.back'),
        });

        return;
      }

      const data = {
        ...this.$route.query,
        lang: this.$i18n.locale,
        p: this.client.phoneType,
        brand_id: this.$route.params.brand,
        dtk: this.client.dtk,
        country_code: AwesomePhonenumber.getCountryCodeForRegionCode(this.cellInstance.getRegionCode()),
        cell: this.cellInstance.getNumber('significant'),
        pwd: this.password,
      };

      eventTarget.classList.add('btn-loading');

      Axios({
        method: 'post',
        url: '/Login_w/login',
        data,
      })
        .then((response) => {
          eventTarget.classList.remove('btn-loading');

          if (response.data.code === 500) {
            this.setUtk(response.data.data.utk);
            this.checkRequirement(response.data.data.require);
            this.autofillUserData(response.data.data.user_data);
            this.$gtm.trackEvent({
              event: '登入',
              label: '手機號碼',
            });
            if (this.profileRequired || this.customFields.length !== 0) {
              this.currentView = 'profile';
            } else {
              this.currentView = 'redirect';
            }
          } else {
            swal.fire({
              text: response.data.msg,
              confirmButtonText: this.$i18n.t('common.back'),
            });
          }
        });
    },
    loginViaWhatsApp(event) {
      const eventTarget = event.target;

      const data = {
        ...this.$route.query,
        lang: this.$i18n.locale,
        p: this.client.phoneType,
        brand_id: this.$route.params.brand,
        dtk: this.client.dtk,
      };

      eventTarget.classList.add('btn-loading');

      Axios({
        method: 'post',
        url: '/Login_w/whatsappAutoLogin',
        data,
      })
        .then((response) => {
          eventTarget.classList.remove('btn-loading');

          if (response.data.code === 500) {
            this.$root.$message.success(this.$i18n.t('entry.loginViaWhatsapp:success'));

            this.setUtk(response.data.data.utk);
            this.checkRequirement(response.data.data.require);
            this.autofillUserData(response.data.data.user_data);
            this.$gtm.trackEvent({
              event: '登入',
              label: 'WhatsApp',
            });
            if (this.profileRequired || this.customFields.length !== 0) {
              this.currentView = 'profile';
            } else {
              this.currentView = 'redirect';
            }
          } else {
            swal.fire({
              text: response.data.msg,
              confirmButtonText: this.$i18n.t('common.back'),
            });
          }
        });
    },

    // Password Reset
    activePasswordReset() {
      this.flow = 'passwordReset';
      this.currentView = 'cell';
    },

    // Cell
    activeSignup() {
      this.flow = 'signup';
      this.currentView = 'cell';
    },
    cancelSignup() {
      this.currentView = 'welcome';
    },

    // Cell
    sendVerifySMS(event) {
      const eventTarget = event.target;

      if (!this.isValidCell) {
        swal.fire({
          text: this.$i18n.t('entry.common:mobileNumberIncorrect'),
          confirmButtonText: this.$i18n.t('common.back'),
        });
        return;
      }

      let recaptcha = '';

      window.grecaptcha.enterprise.ready(async () => {
        eventTarget.classList.add('btn-loading');

        recaptcha = await window.grecaptcha.enterprise.execute('6LexgKQnAAAAABRk6gWZ0-RihcQO-ix7fnpledn-', { action: 'LOGIN' });

        const data = {
          ...this.$route.query,
          lang: this.$i18n.locale,
          p: this.client.phoneType,
          brand_id: this.$route.params.brand,
          dtk: this.client.dtk,
          country_code: AwesomePhonenumber.getCountryCodeForRegionCode(this.cellInstance.getRegionCode()),
          cell: this.cellInstance.getNumber('significant'),
          mode: this.flow,
          recaptcha,
        };

        Axios({
          method: 'post',
          url: '/Login_w/sendVerifyCode',
          data,
        })
          .then((response) => {
            eventTarget.classList.remove('btn-loading');
            if (response.data.code === 500) {
              if (response.data.data.autopass === 1) {
                this.setUtk(response.data.data.utk);
                if (this.flow === 'passwordReset' || this.flow === 'signup') {
                  this.currentView = 'password';
                } else if (this.profileRequired || this.customFields.length !== 0) {
                  this.currentView = 'profile';
                } else {
                  this.currentView = 'redirect';
                }
              } else {
                this.verifySent = true;
                this.$root.$message.success(this.$i18n.t('entry.verify:sent'));
              }
            } else {
              this.verifySent = false;

              this.$root.$message.error(response.data.msg);
            }
          });
      });
    },
    resendVerifySMS() {
      if (this.isSMSResending) {
        return;
      }

      this.isSMSResending = true;

      let recaptcha = '';

      window.grecaptcha.enterprise.ready(async () => {
        recaptcha = await window.grecaptcha.enterprise.execute('6LexgKQnAAAAABRk6gWZ0-RihcQO-ix7fnpledn-', { action: 'LOGIN' });

        const data = {
          ...this.$route.query,
          lang: this.$i18n.locale,
          p: this.client.phoneType,
          brand_id: this.$route.params.brand,
          dtk: this.client.dtk,
          country_code: AwesomePhonenumber.getCountryCodeForRegionCode(this.cellInstance.getRegionCode()),
          cell: this.cellInstance.getNumber('significant'),
          mode: this.flow,
          recaptcha,
        };

        Axios({
          method: 'post',
          url: '/Login_w/sendVerifyCode',
          data,
        })
          .then((response) => {
            if (response.data.code === 500) {
              this.$root.$message.success(this.$i18n.t('entry.verify:sent'));
            } else {
              this.$root.$message.error(response.data.msg);
            }
          })
          .finally(() => {
            this.isSMSResending = false;
          });
      });
    },
    changeCell() {
      this.cell = '';
      this.password = '';
      this.verifySent = false;
    },
    createAutopass() {
      const data = {
        ...this.$route.query,
        lang: this.$i18n.locale,
        p: this.client.phoneType,
        brand_id: this.$route.params.brand,
        dtk: this.client.dtk,
        country_code: AwesomePhonenumber.getCountryCodeForRegionCode(this.cellInstance.getRegionCode()),
        cell: this.cellInstance.getNumber('significant'),
        mode: this.flow,
      };

      Axios({
        method: 'post',
        url: '/initial/createAutoPass',
        data,
      })
        .then((response) => {
          if (response.data.code === 500) {
            this.autopassCell = response.data.data.cell;
            this.autopassSMS = response.data.data.sms_msg;
            this.currentView = 'autopass';
          } else {
            this.$root.$message.error(response.data.msg);
          }
        });
    },
    autopassDone() {
      this.cell = '';
      this.password = '';
      this.verifySent = false;
      this.currentView = 'welcome';
    },
    verifyCell(event) {
      const eventTarget = event.target;

      if (this.verifyCode.trim() === '') {
        swal.fire({
          text: this.$i18n.t('entry.verify:codeEmpty'),
          confirmButtonText: this.$i18n.t('common.back'),
        });
      } else {
        const data = {
          ...this.$route.query,
          lang: this.$i18n.locale,
          p: this.client.phoneType,
          brand_id: this.$route.params.brand,
          dtk: this.client.dtk,
          country_code: AwesomePhonenumber.getCountryCodeForRegionCode(this.cellInstance.getRegionCode()),
          cell: this.cellInstance.getNumber('significant'),
          serial: this.verifyCode.trim(),
          mode: this.flow,
        };

        eventTarget.classList.add('btn-loading');

        Axios({
          method: 'post',
          url: '/Login_w/verifyCell',
          data,
        })
          .then((response) => {
            eventTarget.classList.remove('btn-loading');

            if (response.data.code === 500) {
              this.setUtk(response.data.data.utk);
              this.checkRequirement(response.data.data.require);
              this.autofillUserData(response.data.data.user_data);
              this.$root.$message.success(this.$i18n.t('entry.verify:success'));
              if (this.flow === 'passwordReset' || this.cellRequired) {
                this.currentView = 'password';
              } else if (this.profileRequired || this.customFields.length !== 0) {
                this.currentView = 'profile';
              } else {
                this.currentView = 'redirect';
                this.$gtm.trackEvent({
                  event: '登入',
                  label: '手機號碼',
                });
              }
            } else {
              this.$root.$message.error(response.data.msg);
            }
          });
      }
    },
    setPassword(event) {
      const eventTarget = event.target;

      if (this.newPassword !== this.newPasswordComfirm) {
        this.$root.$message.error(this.$i18n.t('entry.password:notMatch'));
        this.newPassword = '';
        this.newPasswordComfirm = '';

        return;
      }

      const data = {
        ...this.$route.query,
        lang: this.$i18n.locale,
        p: this.client.phoneType,
        dtk: this.client.dtk,
        brand_id: this.$route.params.brand,
        pwd: this.newPassword,
        mode: this.flow,
      };

      eventTarget.classList.add('btn-loading');

      Axios({
        method: 'post',
        url: '/User/UpdateUser',
        data,
      })
        .then((response) => {
          eventTarget.classList.remove('btn-loading');
          if (response.data.code === 500) {
            if (this.flow === 'passwordReset') {
              swal.fire({
                text: this.$i18n.t('entry.password:success'),
                confirmButtonText: this.$i18n.t('common.ok'),
              })
                .then(() => {
                  this.flow = null;
                  this.currentView = 'welcome';
                });
            } else if (this.profileRequired || this.customFields.length !== 0) {
              this.currentView = 'profile';
            } else {
              this.currentView = 'redirect';
            }
          } else {
            this.$root.$message.error(response.data.msg);
          }
        });
    },

    // Profile
    setProfile(event) {
      const eventTarget = event.target;

      if (!this.name) {
        swal.fire({
          text: this.$i18n.t('entry.profile:nameEmpty'),
          confirmButtonText: this.$i18n.t('common.ok'),
        });
        return;
      }

      if (this.gender === null) {
        swal.fire({
          text: this.$i18n.t('entry.profile:genderEmpty'),
          confirmButtonText: this.$i18n.t('common.ok'),
        });
        return;
      }

      if (!this.birthday) {
        swal.fire({
          text: this.$i18n.t('entry.profile:birthdayEmpty'),
          confirmButtonText: this.$i18n.t('common.ok'),
        });
        return;
      }

      if (this.customFields.length !== 0) {
        const emptyCustomFields = [];
        this.customFields.forEach((field) => {
          if (field.mandatory === true &&
            (this.customFieldsData[field.field] === null || this.customFieldsData[field.field] === '')
          ) {
            let fieldName = '';
            if (field.field) {
              fieldName = field.label;
            } else if (field === 'email') {
              fieldName = 'Email';
            } else if (field === 'loc') {
              fieldName = this.$i18n.t('entry.profile:location');
            }

            emptyCustomFields.push(fieldName);
          }
        });

        if (emptyCustomFields.length > 0) {
          swal.fire({
            text: this.$i18n.t('entry.profile:customFieldsEmpty', { field: emptyCustomFields[0] }),
            confirmButtonText: this.$i18n.t('common.ok'),
          });
          return;
        }

        const invalidCustomFields = [];

        this.customFields.forEach((field) => {
          if (field.mandatory === false &&
            (this.customFieldsData[field.field] === null || this.customFieldsData[field.field] === '')
          ) {
            return;
          }

          if (field.type === 'email') {
            const emailRe = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!emailRe.test(this.customFieldsData[field.field])) {
              invalidCustomFields.push('email');
            }
          } else if (field.pattern) {
            const re = new RegExp(field.pattern);
            if (!re.test(this.customFieldsData[field.field])) {
              invalidCustomFields.push(field);
            }
          }
        });

        if (invalidCustomFields.length > 0) {
          let fieldName = '';
          if (invalidCustomFields[0].field) {
            fieldName = invalidCustomFields[0].label;
          } else if (invalidCustomFields[0] === 'email') {
            fieldName = 'Email';
          } else if (invalidCustomFields[0] === 'loc') {
            fieldName = this.$i18n.t('entry.profile:location');
          }

          swal.fire({
            text: invalidCustomFields[0].help ? this.$i18n.t('entry.profile:customFieldsInvalidWithHelp', { field: fieldName, help: invalidCustomFields[0].help }) : this.$i18n.t('entry.profile:customFieldsInvalid', { field: fieldName }),
            confirmButtonText: this.$i18n.t('common.ok'),
          });
          return;
        }
      }

      swal.fire({
        text: this.$i18n.t('entry.profile:notice'),
        confirmButtonText: this.$i18n.t('common.submit'),
        showCancelButton: true,
        cancelButtonText: this.$i18n.t('common.cancel'),
        reverseButtons: true,
      })
        .then((result) => {
          if (result.value) {
            eventTarget.classList.add('btn-loading');

            const data = {
              ...this.$route.query,
              lang: this.$i18n.locale,
              p: this.client.phoneType,
              brand_id: this.$route.params.brand,
              dtk: this.client.dtk,
              name: this.name,
              sex: this.gender,
              birth: moment(this.birthday).format('YYYY/MM/DD'),
              mode: this.flow,
            };

            if (this.customFieldsData !== {}) {
              data.custom_fields = this.customFieldsData;
            }

            Axios({
              method: 'post',
              url: '/User/UpdateUser',
              data,
            })
              .then((response) => {
                eventTarget.classList.remove('btn-loading');
                if (response.data.code === 500) {
                  this.currentView = 'redirect';
                } else {
                  this.$root.$message.error(response.data.msg);
                }
              });
          }
        });
    },
  },
  created() {
    const googleReCaptchaScript = document.createElement('script');
    googleReCaptchaScript.src = 'https://www.google.com/recaptcha/enterprise.js?render=6LexgKQnAAAAABRk6gWZ0-RihcQO-ix7fnpledn-';
    document.head.appendChild(googleReCaptchaScript);

    const data = {
      ...this.$route.query,
      lang: this.$i18n.locale,
      p: this.client.phoneType,
      brand_id: this.$route.params.brand,
      dtk: this.client.dtk,
    };

    Axios({
      method: 'post',
      url: '/Login_w/verifyLogin',
      data,
    })
      .then((response) => {
        if (response.data.code === 500) {
          this.ui = response.data.data.brand;
          this.cellCountry = response.data.data.brand.country_iso;

          this.ui.requiredEn = this.ui.required
            .replace(/、/g, ', ')
            .replace('手機號碼', 'mobile number')
            .replace('姓名', 'full name')
            .replace('性別', 'gender')
            .replace('生日', 'date of birth');

          document.title = this.ui.name;
          this.title = response.data.data.welcome;
          this.checkRequirement(response.data.data.required);
          this.autofillUserData(response.data.data.user_data);

          if (response.data.data.utk) {
            this.setUtk(response.data.data.utk);
          }

          const isVip = Boolean(response.data.data.is_vip);
          const isLoggedIn = Boolean(response.data.data.logged_in);

          if (response.data.data.whatsapp_data && response.data.data.whatsapp_data.phone) {
            this.whatsappAccount = response.data.data.whatsapp_data.phone;
          }

          if (isLoggedIn) {
            if (!isVip) {
              this.currentView = 'invite';
              this.setLoader(false);
            } else if (this.cellRequired || this.profileRequired || this.customFields.length !== 0) {
              this.currentView = 'lack';
              this.setLoader(false);
            } else {
              this.currentView = 'redirect';
            }
          } else {
            this.setLoader(false);
          }

          if (this.$route.query.via === 'ocard-rewards-partner') {
            if (response.data.data.cell) {
              this.cellCountry = AwesomePhonenumber(response.data.data.cell).getRegionCode();

              const cellInstance = new AwesomePhonenumber(response.data.data.cell, this.cellCountry);
              this.cell = cellInstance.getNumber('significant');
            }
          }

          this.isCellLoginAllow = response.data.data.sms_enable || false;

          if (!isLoggedIn && response.data.data.whatsapp_data && response.data.data.whatsapp_data.phone) {
            this.currentView = 'login-via-whatsapp';
          }
        }
      });
  },
  components: {
    Loader,
    I18nPicker,
    Background,
    FixedHeader,
    CountrySelect,
    Datepicker,
  },
};
</script>

<style lang="sass" scoped>
@import '../../../assets/sass/compoments/o-panel.sass'
@import '../../../assets/sass/compoments/o-form.sass'

$cb: cubic-bezier(.4, 0, .2, 1)

.view
  width: 100%
  height: 100%

.main
  height: 100%
  color: white
  overflow-x: hidden

.panel
  &--welcome
    text-align: center

    .title
      margin: 1em 0

    .caption
      text-align: left
      font-size: 0.75rem

  &--cell
    .recaptcha-terms
      margin: 8px 0
      font-size: 12px
      color: rgba(255, 255, 255, 0.5)

  &--autopass
    .panel-header
      .icon
        .material-icons
          font-size: 2.875rem

    .panel-body
      text-align: left

      .caption
        font-weight: bold
        color: white

      .autopassSMS
        width: 100%

  &--profile
    .custom-fields-title
      margin: 12px 0

      text-align: center
      color: #3F51B5
      font-weight: bold
      font-size: 0.875rem

.form
  .gap
    height: 1em

  input[type=text],
  input[type=number],
  input[type=tel],
  input[type=password]
    width: 100%

    padding: 10px 15px

    border: none
    border-radius: 23px

    font-weight: 700
    color: #333

    &:focus
      outline: none

  .readonly
    pointer-events: none

  .cell-country
    width: 100%
    padding: 10px 15px
    overflow: hidden

    border: none
    border-radius: 23px

    background-color: #ffea00
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAwCAYAAACooNxlAAAABGdBTUEAALGPC/xhBQAAAYxJREFUaAXt1T9ugzAUBnAMQ5Zmh1vwZ2qToVvVC+Qulao26aWabjkBp4gEe3bo+9JYslCRYgPCSJ8lBwh5j+cfthMEbBSgAAUoQAEKUIACFKAABShAAQpQgAIUcBHIsuxd+qNLrBlTFMVW+pv53ZznkcvDZQBfSqm99F0cx6e6rs+OebZt235LntckSVRVVSeXPGPGWIPIrDjIAD5uRaxcUTAzbhgPyCV5nn1ACW11pfC2E7MOw/DHZvmkaboxMTr5Zr20niGY1niTeKNG5XfPFGAI4FHirzND5xCgQ1mWe30919EaBIW6ogAjiiLsGWtzwL5goCYnEATaomgMCfUWA+NyBkHwvSiC8SQz4yghXmNgTAofQ1ue5/gL/uzkuTRN8yLLQS0FA/WPAoJEfSi4J837mfFX5sAlo5Pg2Ld85NbK/J1PG6hZlz4ftIfoJPrYg6JvB75joNBRQZCwD2UJGJOA/IeyFAzUPmnDRos+6UOYnAIUoAAFKEABClCAAhSgAAUoQAEKUGCQwC/1HLKALR1EkwAAAABJRU5ErkJggg==')
    background-size: 24px
    background-repeat: no-repeat
    background-position: right center

    font-weight: 700
    color: #333

    -webkit-padding-end: 24px
    appearance: none
    text-overflow: ellipsis
    white-space: nowrap

    &:disabled
      opacity: 1

      background-image: none

    &__container
      height: 44px

      border-radius: 23px 0 0 23px

      background-color: white

    &::after
      content: ''

    &:focus
      outline: none

  .cell[type=tel]
    border-radius: 0 23px 23px 0

  .invisable-submit
    visibility: hidden
    position: absolute
</style>

<style lang="sass">
$cb: cubic-bezier(.4, 0, .2, 1)

.caption,
.recaptcha-terms
  a
    color: rgba(255, 255, 255, 0.5)
    text-decoration: underline

.panel-enter-active
  transition: opacity .25s $cb .1s, transform .25s $cb .1s

.panel-enter
  opacity: 0
  transform: translateX(20%)

.panel-leave-active
  transition: opacity .4s $cb, transform .4s $cb

.panel-leave-to
  position: absolute
  left: 0
  right: 0
  opacity: 0
  transform: scale(.9)
</style>


<style lang="sass">
.ui-datepicker
  margin-bottom: 0

  font-family: inherit

  &__display
    border: none

    font-family: inherit

    &-value
      font-size: 1.5rem

      &.is-placeholder
        font-size: inherit

      &::after
        font-family: 'Material Icons'
        font-weight: normal
        font-style: normal
        font-size: 1.5rem
        line-height: 1
        letter-spacing: normal
        text-transform: none
        display: inline-block
        white-space: nowrap
        word-wrap: normal
        direction: ltr
        -webkit-font-feature-settings: 'liga'
        -webkit-font-smoothing: antialiased

        content: 'create'

        font-size: 1.2081rem
        opacity: .5

  &__modal-buttons
    justify-content: center

    .ui-button:last-child
      display: none

.ui-modal,
.ui-calendar
  font-family: inherit

.ui-calendar
  &__header
    background-color: #ffea00 !important

    color: #333

    &-year
      opacity: 1 !important
      margin-bottom: 0

      text-align: center
      font-size: 1.2081rem
      font-weight: bold

      &:focus
        outline: none

      &::after
        font-family: 'Material Icons'
        font-weight: normal
        font-style: normal
        font-size: 1.5rem
        line-height: 1
        letter-spacing: normal
        text-transform: none
        display: inline-block
        white-space: nowrap
        word-wrap: normal
        direction: ltr
        -webkit-font-feature-settings: 'liga'
        -webkit-font-smoothing: antialiased

        content: 'expand_more'

        font-size: 1.2081rem
        opacity: .5

        transform: translateY(2px)

    &-details
      display: none

  &__years
    -webkit-overflow-scrolling: touch

  &__year
    &:hover
      color: #3F51B5 !important

    &.is-selected
      color: #3F51B5 !important
      font-weight: bold

  &-week__date
    &.is-today
      color: #3F51B5 !important

    &.is-selected
      background-color: #3F51B5 !important

.ui-icon-button
  &:focus
    outline: 0

.ui-button
  flex-grow: 1
  margin: 0 .5em .5em
  border-radius: 99px

  background-color: #ffea00

  font-weight: bold !important
  color: #333 !important

  &:focus
    outline: 0

.grecaptcha-badge
  display: none
</style>
